import React from 'react';
import { makeStyles, Typography, Grid } from '@material-ui/core';
import StatCard from './StatCard';

const useStyles = makeStyles((theme) => ({
    section: {
        border: '1px solid #e8e8e8',
        borderRadius: 10,
        padding: theme.spacing(2),
        backgroundColor: '#fafafa',
        height: '100%',
        boxSizing: 'border-box',
    },
    label: {
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: '0.08em',
        color: '#888',
        textTransform: 'uppercase',
        marginBottom: theme.spacing(1.5),
    },
}));

export default function ApplicationSection({ title, cards, subtext }) {
    const classes = useStyles();

    return (
        <div className={classes.section}>
            <Typography className={classes.label}>{title}</Typography>
            <Grid container spacing={2}>
                {cards.map((card) => (
                    <Grid item xs={6} key={card.label}>
                        <StatCard
                            label={card.label}
                            value={card.value}
                            change={card.change}
                            icon={card.icon}
                            absolute={card.absolute}
                            subtext={subtext}
                        />
                    </Grid>
                ))}
            </Grid>
        </div>
    );
}
